"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImplicitHydrogensCount = getImplicitHydrogensCount;
function getImplicitHydrogensCount(molecule, atomID) {
    molecule.ensureHelperArrays(molecule.getOCL().Molecule.cHelperNeighbours);
    return (molecule.getAllHydrogens(atomID) +
        molecule.getConnAtoms(atomID) -
        molecule.getAllConnAtoms(atomID));
}
//# sourceMappingURL=getImplicitHydrogensCount.js.map